import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import * as Constant from '../../constants'
import cookie from 'react-cookies'

// Exporting private route function for validating routes. 
function PrivateRoute({ component: Component, ...rest }) {
    let data =  cookie.load(Constant.USER_DATA);
    return (
        <Route {...rest} render={props => (
            (data) ? <Component {...props} /> : <Redirect to="/login" />
        )}></Route>
    );
};

export default PrivateRoute;